<script setup lang="ts">
import '@/styles';
import { useHead } from '@unhead/vue';

defineProps<{ error?: string }>();

useHead({
  titleTemplate: (title) => (title ? title + ' - ' : '') + $t`Castalian Spring`,
});
</script>

<template>
  <h1>404 {{ $t`Not found` }}</h1>
  <p v-if="error">{{ error }}</p>
</template>
